import * as React from 'react';

export const EndIconSvg = () => (
  <svg viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.49999 4.03589L5.5 6.53589V1.53589L8.49999 4.03589Z"
      fill="currentColor"
    />
    <path d="M6.5 3.57184V4.57184H0.5V3.57184H6.5Z" fill="currentColor" />
    <path d="M11 7.07178H10V1.07178L11 1.07178V7.07178Z" fill="currentColor" />
  </svg>
);
